import styled from "styled-components";

export const StyledTitle = styled.h1`
  text-align: center;
`;
